import { Router } from 'router/router.tsx';
import { useInitMyUser } from 'shared/hooks/use-init-my-user.ts';
import { useSocket } from './socket/use-socket.ts';
import './app.scss';

const App = () => {
  const { isLoading } = useInitMyUser();
  useSocket();

  if (isLoading) return <div />;

  return <Router />;
};

export default App;
